process = (remainingMiddlewares) ->
  (action) ->
    return if remainingMiddlewares.length is 0
    middleware      = remainingMiddlewares[0]
    nextMiddlewares = remainingMiddlewares.slice(1, remainingMiddlewares.length)
    next            = process(nextMiddlewares)

    mProcess =
      middleware.process or process_type(middleware.type, middleware.commands)

    mProcess(action, next) if action?


process_type = (only_type, commands) ->
  ({ type, command, params }, next) ->
    if type is only_type
      new_command = commands(next)[command]
      if new_command?
        next new_command(params...)
      else
        next { type, command, params }
    else
      next { type, command, params }

run = (command, method, id_generator) ->
  iframe = document.createElement("IFRAME")
  code   = method command, id_generator
  url    = "gap-code://#{escape(unescape(encodeURIComponent(code)))}"
  iframe.setAttribute("src", url)
  document.documentElement.appendChild(iframe)
  iframe.parentNode.removeChild(iframe)
  iframe = null


registeredMiddlewares = []
registerMiddlewares = (middlewareList) ->
  loaded = []
  for middlewareToLoad in middlewareList
    try
      loadedMiddleware = middlewareToLoad
      loaded.push loadedMiddleware
    catch err
      console.error "Error while requiring #{middlewareToLoad}", err

  registeredMiddlewares = loaded
  Backbone.Events.on "publish", process(registeredMiddlewares)

_action = (type, command, direction = "publish") ->
  (params...) ->
    event = direction
    event += ":#{type}:#{command}" if direction is "subscribe"
    Backbone.Events.trigger event, {
      type
      command
      params
    }

possibleActions = {}
fillPossibleActions = (middlewares, active) ->
  possibleActions = {}
  for m in middlewares
    if m.type?
      name = m.type[0].toUpperCase() + m.type[1..]
      possibleActions[name] = {}
      if m.commands?
        for command, val of m.commands()
          possibleActions[name][command] = _action(m.type, command)

registerPlatformMiddlewares = (platforms, my_platform) ->
  allMiddlewares = []
  for platform, middlewares of platforms when platform isnt my_platform
    allMiddlewares = allMiddlewares.concat(middlewares)
  allMiddlewares = allMiddlewares.concat(platforms[my_platform])

  fillPossibleActions(allMiddlewares)

  # Predefined platform with a list of middlewares
  if _.isString(my_platform)
    registerMiddlewares(platforms[my_platform])

  # Custom list of middlewares
  else if _.isArray(my_platform)
    registerMiddlewares(my_platform)


actions = (type) ->
  if type?
    possibleActions?[type]
  else
    possibleActions

action  = (direction = "publish") ->
  (namespace) ->
    [ type, command ] = namespace.split /\:/
    _action(type, command, direction)


platforms =
  browser: [
    require("lib/middleware/session")
    require("lib/middleware/backbone_event")
    require("lib/middleware/webview")
    require("lib/middleware/browser/analytics")
    require("lib/middleware/browser/app_lesson")
    require("lib/middleware/browser/sound")
  ]
  scorm: [
    require("lib/middleware/session")
    require("lib/middleware/backbone_event")
    require("lib/middleware/webview")
    require("lib/middleware/scorm/scorm_analytics")
    require("lib/middleware/scorm/scorm_lesson")
    require("lib/middleware/browser/sound")
  ]


initialize = (platform) ->
  platform ?= window.__?.platform or "browser"
  window.build_platform = platform #save platform for individual middleware to use

  registerPlatformMiddlewares platforms, platform


module.exports = {
  process
  run
  initialize
  actions
  action: action()
  publish: action("publish")
  subscribe: action("subscribe")
}
